const formBuilder = (fields, vm) => {
  const dict = fields.reduce((acc, field) => {
    const obj = acc;
    const val = vm[field];
    const emptyKeywords = [null, undefined, ""];
    const isEmpty = emptyKeywords.indexOf(val) !== -1;

    obj[field] = isEmpty ? null : vm[field];

    return obj;
  }, {});

  return JSON.parse(JSON.stringify(dict));
};

export default formBuilder;
